import { NavLink } from 'react-router-dom'
import { NavItems } from '../../constants/mockdata'

const NavMenu = () => {
  return (
    <ul className="flex justify-center gap-6">
      {NavItems.map((item) => (
        <li key={item.key}>
          <NavLink
            to={`/${item.key}`}
            className={({ isActive }) =>
              isActive
                ? 'text-base font-bold text-black dark:text-gray-300'
                : 'text-base font-medium text-black dark:text-gray-300 hover:font-bold transition-all duration-300'
            }
          >
            {item.label}
          </NavLink>
        </li>
      ))}
    </ul>
  )
}

export default NavMenu
